/**
 * Lottie
 */

var component_lottie = function() {

  const items = document.querySelectorAll('.lottie__animation');

  // validate
  if (!items) {
    console.log('no lottie container suplied');
    return;
  }

  /**
   * Init
   */
   function init_component_lottie() {

    document.addEventListener('DOMContentLoaded', function () {

      const automaattitasaus = document.getElementById('automaattitasaus');
      const helppokayttoisyys = document.getElementById('helppokayttoisyys');
      const huoltonaytto = document.getElementById('huoltonaytto');
      const joystick_ohjaus = document.getElementById('joystick-ohjaus');
      const kapea_koko = document.getElementById('kapea-koko');
      const kayttajaystavallisyys = document.getElementById('kayttajaystavallisyys');
      const monikayttoisyys = document.getElementById('monikayttoisyys');
      const nopein_siirtoajo = document.getElementById('nopein-siirtoajo');
      const teknologinen_edellakavijyys = document.getElementById('teknologinen-edellakavijyys');
      const nopeakayttoonotto = document.getElementById('nopea-kayttoonotto');

      if (automaattitasaus) {
        LottieInteractivity.create({
          player:'#automaattitasaus',
          mode:"scroll",
          actions: [
              {
              visibility: [0.25, 1.0],
              type: "play"
              }
          ]
        });

        LottieInteractivity.create({
          player:'#automaattitasaus',
          mode:"cursor",
          actions: [
              {
                  type: "hover",
                  forceFlag: false
              }
          ]
        });
      }

      if (nopeakayttoonotto) {
        LottieInteractivity.create({
          player:'#nopea-kayttoonotto',
          mode:"scroll",
          actions: [
              {
              visibility: [0.25, 1.0],
              type: "play"
              }
          ]
        });

        LottieInteractivity.create({
          player:'#nopea-kayttoonotto',
          mode:"cursor",
          actions: [
              {
                  type: "hover",
                  forceFlag: false
              }
          ]
        });
      }

      if (helppokayttoisyys) {
        LottieInteractivity.create({
          player:'#helppokayttoisyys',
          mode:"scroll",
          actions: [
              {
              visibility: [0.25, 1.0],
              type: "play"
              }
          ]
        });

        LottieInteractivity.create({
          player:'#helppokayttoisyys',
          mode:"cursor",
          actions: [
              {
                  type: "hover",
                  forceFlag: false
              }
          ]
        });
      }

      if (huoltonaytto) {
        LottieInteractivity.create({
          player:'#huoltonaytto',
          mode:"scroll",
          actions: [
              {
              visibility: [0.25, 1.0],
              type: "play"
              }
          ]
        });

        LottieInteractivity.create({
          player:'#huoltonaytto',
          mode:"cursor",
          actions: [
              {
                  type: "hover",
                  forceFlag: false
              }
          ]
        });
      }

      if (joystick_ohjaus) {
        LottieInteractivity.create({
          player:'#joystick-ohjaus',
          mode:"scroll",
          actions: [
              {
              visibility: [0.25, 1.0],
              type: "play"
              }
          ]
        });

        LottieInteractivity.create({
          player:'#joystick-ohjaus',
          mode:"cursor",
          actions: [
              {
                  type: "hover",
                  forceFlag: false
              }
          ]
        });
      }

      if (kapea_koko) {
        LottieInteractivity.create({
          player:'#kapea-koko',
          mode:"scroll",
          actions: [
              {
              visibility: [0.25, 1.0],
              type: "play"
              }
          ]
        });

        LottieInteractivity.create({
          player:'#kapea-koko',
          mode:"cursor",
          actions: [
              {
                  type: "hover",
                  forceFlag: false
              }
          ]
        });
      }

      if (kayttajaystavallisyys) {
        LottieInteractivity.create({
          player:'#kayttajaystavallisyys',
          mode:"scroll",
          actions: [
              {
              visibility: [0.25, 1.0],
              type: "play"
              }
          ]
        });

        LottieInteractivity.create({
          player:'#kayttajaystavallisyys',
          mode:"cursor",
          actions: [
              {
                  type: "hover",
                  forceFlag: false
              }
          ]
        });
      }

      if (monikayttoisyys) {
        LottieInteractivity.create({
          player:'#monikayttoisyys',
          mode:"scroll",
          actions: [
              {
              visibility: [0.25, 1.0],
              type: "play"
              }
          ]
        });

        LottieInteractivity.create({
          player:'#monikayttoisyys',
          mode:"cursor",
          actions: [
              {
                  type: "hover",
                  forceFlag: false
              }
          ]
        });
      }

      if (nopein_siirtoajo) {
        LottieInteractivity.create({
          player:'#nopein-siirtoajo',
          mode:"scroll",
          actions: [
              {
              visibility: [0.25, 1.0],
              type: "play"
              }
          ]
        });

        LottieInteractivity.create({
          player:'#nopein-siirtoajo',
          mode:"cursor",
          actions: [
              {
                  type: "hover",
                  forceFlag: false
              }
          ]
        });
      }

      if (teknologinen_edellakavijyys) {
        LottieInteractivity.create({
          player:'#teknologinen-edellakavijyys',
          mode:"scroll",
          actions: [
              {
              visibility: [0.25, 1.0],
              type: "play"
              }
          ]
        });

        LottieInteractivity.create({
          player:'#teknologinen-edellakavijyys',
          mode:"cursor",
          actions: [
              {
                  type: "hover",
                  forceFlag: false
              }
          ]
        });
      }
    });


    return;
  }
  init_component_lottie();

  // make the call chainable
  return this;
};
